import alertManagement from "./alertManagement/en";
import assetManagement from "./assetManagement/en";
import configurator from "./configurator/en";
import development from "./development/en";
import deviceManagement from "./deviceManagement/en";
import securityCenter from "./securityCenter/en";
import softwareManagement from "./softwareManagement/en";

import feedback from "./feedback/en";
import groups from "./groups/en";
import fleetInventory from "./fleetInventory/en";
import settings from "./settings/en";
import noAccessMessage from "./noAccessMessage/en";
import home from "./home/en";
import userManagement from "./userManagement/en";

export default {
  development,
  configurator,
  alertManagement,
  feedback,
  groups,
  fleetInventory,
  settings,
  assetManagement,
  deviceManagement,
  securityCenter,
  softwareManagement,
  noAccessMessage,
  home,
  userManagement,
};
